'use client';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { useSelectedLayoutSegment } from 'next/navigation';
import { PageHeader } from '../../../PageHeader/PageHeader';

function InboxPageHeader() {
  const t = useTranslations('my_account.inbox');
  const selectedSegment = useSelectedLayoutSegment();
  const isInboxMessage = selectedSegment !== null;

  return (
    <PageHeader
      variant="subheader"
      title={isInboxMessage ? '' : t('title')}
      fallbackUrl={isInboxMessage ? ROUTES.MY_ACCOUNT.INBOX : ROUTES.MY_ACCOUNT.ROOT}
      className="flex items-center gap-4 z-10 ll-container-inner py-6"
    />
  );
}

export { InboxPageHeader };
